// extracted by mini-css-extract-plugin
export default {"tab":"crYcV","tab__text":"Y5Fsv","tab--active":"oUSwU"};